const routeIncludeCheck = (pathname: string, menuItemPath: string) => {
  if (pathname?.includes(menuItemPath)) {
    return true;
  } else {
    return false;
  }
};

export default routeIncludeCheck;
